import { StorePreferences } from '@nextforce/api'

export const DEFAULT_STORE_PREFERENCES: StorePreferences = {
  allowNewOpenShift: false,
  allowAddAndAssign: false,
  allowEmptyPosition: false,
  shiftIncrements: 15,
  maxShiftDays: 15,
  maxShiftDuration: 720,
  minShiftDuration: 30,
  maxCriticalAmount: 100,
  minCriticalAmount: 5,
  nextShiftSplitterEnabled: false,
  nextShiftSplitterLength: 60,
  allowCrossStoreSharingForObservers: true,
  showTimeOffRequest: false,
  newShiftDefaults: {},
  showNonAvailability: false,
  enableCustomTasks: false,
  showStoreScheduleToHelpers: false,
}
